<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>合同名称</label>
                </div>
                <div class="form-value">
                    <span>{{contract.title}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="contract.contractCheckFileList != null && contract.contractCheckFileList.length > 0">
                <div class="form-label">
                    <label>验收附件</label>
                </div>
                <div class="form-value">
                    <swb-save-file :showDelete="false" :files="contract.contractCheckFileList" ref="swb_contract_file"></swb-save-file>
                </div>
            </div>
            <div class="form-group center" v-if="contract.contractCheckFileList != null && contract.contractCheckFileList.length == 0">
                <div class="form-label">
                    <label>验收附件</label>
                </div>
                <div class="form-value">
                    <swb-save-file :showDelete="false" :files="contract.contractCheckFileList" ref="swb_contract_file"></swb-save-file>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import contractApi from '../../api/contract'

    import SwbSaveFile from './SaveFile';
    Vue.regist(SwbSaveFile);

    export default {
        name: 'swb-check-contract',
        desc: '合同-验收',
        props: {
            contractId: {
                type: Number
            }
        },
        data: function () {
            return {
                contract: {}
            }
        },
        created: function () {
            let contractId = this.contractId;
            if(contractId != null) {
                this.getContractInfo(contractId);
            } else {
                MsgBox.warning("合同选择有误");
                return false;
            }
        },
        methods: {
            getContractInfo: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type === "info") {
                        self.contract = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                //
                let contractCheckFileList = [];
                let result = self.$refs.swb_contract_file.getDlgResult() || {};
                if(result.data.length > 0) {
                    if(result.type === 'info') {
                        contractCheckFileList = Utils.copyAsArray(result.data);
                        result.data = contractCheckFileList;
                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                } else {
                    MsgBox.warning("请上传验收文件");
                    return false;
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/contract/CheckContract.vue